import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface FabProps {
    href?: string
    onClick?: () => void
    label: string
    icon: ReactNode
    className?: string
}

/* The floating action button above the bottom navigation on phones. */
export const Fab: FC<FabProps> = ({ href, onClick, label, icon, className }): ReactNode => {
    const classes = cn(
        'fixed right-4 bottom-[calc(5rem+env(safe-area-inset-bottom))] z-30 inline-flex h-14 items-center gap-2 rounded-2xl bg-primary pr-5 pl-4 text-[15px] font-bold text-primary-foreground shadow-primary transition-transform active:scale-95 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none lg:hidden print:hidden [&_svg]:size-6',
        className
    )

    if (href) {
        return (
            <Link href={href} className={classes}>
                {icon}
                {label}
            </Link>
        )
    }

    return (
        <button type='button' onClick={onClick} className={classes}>
            {icon}
            {label}
        </button>
    )
}
